var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBlueWhatWeDoBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 1900,
    height: 1708,
    viewBox: "0 0 1900 1708",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_404_2991)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-1900 0H1900V1848H-1900V0Z",
    fill: "url(#paint0_radial_404_2991)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint0_radial_404_2991",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(1584.12 -210.77) rotate(150.708) scale(3994.93 6354.85)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#0C80D9",
    stopOpacity: 0.9
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.104518,
    stopColor: "#0C80D9",
    stopOpacity: 0.5
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.221895,
    stopColor: "#0C80D9",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.325769,
    stopColor: "#0C80D9",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_404_2991"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 2052,
    height: 1708,
    fill: "white",
    transform: "translate(-152)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlueWhatWeDoBg);
export default __webpack_public_path__ + "static/media/blue-what-we-do-bg.00db41b5f0ea6401ac2eaaa8cbc3f404.svg";
export { ForwardRef as ReactComponent };